import React, {useEffect} from "react";
import {Skeleton, Dialog, DialogTitle, DialogContent, IconButton, Typography,  ListItem, ListItemText} from "@mui/material";
import CloseIcon from "../../../assets/icons/close.png";
import moment from "moment";
import useAuthentication from "../../../hooks/useAuthentication";

const DocumentAuthenticationViewDialog = (props) => {

    const {openDocumentView, setOpenDocumentView, documentId} = props;

    const {isViewDocument, documentViewDetails, getDocumentAuthenticationViewDetails} = useAuthentication();

    const handleCloseDialog = () => {
        setOpenDocumentView(false);
    }

    useEffect(() => {
        if (documentId) {
            getDocumentAuthenticationViewDetails(documentId);
        }
    }, [documentId])


    return (
        <Dialog open={openDocumentView} onClose={handleCloseDialog} maxWidth="sm" fullWidth PaperProps={{style: {borderRadius: "8px", padding: " 20px 24px"}, elevation: 24}}>
            <DialogTitle sx={{display: "flex"}}>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={{position: 'absolute', right: 36, top: 24}}
                >
                    <img alt="close-icon" src={CloseIcon} style={{height: 22}} />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{padding: "20px 8px"}}>
                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Document ID:
                            </Typography>
                        } 
                        secondary={(isViewDocument) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, fontWeight: 500, ml: 1}}>
                                {documentViewDetails?.document_id}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Content Type:
                             </Typography>
                        } 
                        secondary={(isViewDocument) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {documentViewDetails?.content_type}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Document Type:  
                             </Typography>
                        } 
                        secondary={(isViewDocument) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {documentViewDetails?.document_type}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                OVCode Reference:
                             </Typography>
                        } 
                        secondary={(isViewDocument) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {documentViewDetails?.ovcode_reference}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Issued By:  
                             </Typography>
                        } 
                        secondary={(isViewDocument) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {documentViewDetails?.issued_by}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Authentication Status: 
                             </Typography>
                        } 
                        secondary={(isViewDocument) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{fontSize: 16, ml: 1, color: 
                                (documentViewDetails?.authentication_status == "Completed") ? 
                                    "#40BF7E" 
                                : 
                                    (documentViewDetails?.authentication_status == "Pending") ?
                                        "#FFA500" 
                                :
                                    "#E76C59" 
                            }}>
                                {documentViewDetails?.authentication_status}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Date Created:   
                             </Typography>
                        } 
                        secondary={(isViewDocument) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {moment(documentViewDetails?.created_time).format('YYYY-MM-DD hh:mm:ss A')}
                            </Typography>
                        }
                    />
                </ListItem>

                <ListItem sx={{pt: "2px", pb: "2px"}}>
                    <ListItemText sx={{display: "flex", mt: "4px", mb: "4px"}}
                        primary={
                            <Typography sx={{color: "#58565f", fontSize: 16, fontWeight: "bold"}}>
                                Date Updated:   
                             </Typography>
                        } 
                        secondary={(isViewDocument) ?
                            <Skeleton variant="text" sx={{fontSize: 14, width: "300px", backgroundColor: "#d8d8fdbd", ml: 1}} />
                        :
                            <Typography sx={{ color: "#58565f", fontSize: 16, ml: 1}}>
                                {moment(documentViewDetails?.updated_time).format('YYYY-MM-DD hh:mm:ss A')}
                            </Typography>
                        }
                    />
                </ListItem>
            </DialogContent>
        </Dialog>
    )
}

export default DocumentAuthenticationViewDialog

